import { getCoreDataSecurityStatusSlice } from './get';
import { postCoreDataSecurityStatusSlice } from './post';

export const { requestGetCoreDataSecurityStatus, resetGetCoreDataSecurityStatus } =
    getCoreDataSecurityStatusSlice.asyncActionCreators;

export const { requestPostCoreDataSecurityStatus, resetPostCoreDataSecurityStatus } =
    postCoreDataSecurityStatusSlice.asyncActionCreators;
